window.lang2 =
{
  "general": {
    "meta": {
      "tags": "Märkt med \"{{ tags }}\"",
      "page": "Sida {{ page }}"
    },
    "404": {
      "title": "404 Sidan Hittas Inte",
      "subtext_html": "Sidan du begärde finns inte.",
      "click_here": "Klicka här",
      "continue_shopping": "för att fortsätta handla."
    },
    "breadcrumbs": {
      "home": "Hem",
      "cart": "Kundvagn",
      "home_link_title": "Tillbaka till hemsidan"
    },
    "newsletter_form": {
      "newsletter_email": "email@exempel.com",
      "submit": "Att skicka",
      "newsletter_text": "Skriv in din mailadress"
    },
    "search": {
      "title": "Sök efter artiklar på vår webbplats",
      "placeholder": "Sök",
      "submit": "Sök",
      "no_results": "inga resultat",
      "view_results": "Visa alla resultat"
    },
    "filters": {
      "show": "Objekt per sida",
      "show_more": "Läs mer",
      "show_less": "Läs mindre"
    },
    "currency": {
      "change_text": "Valutan har ändrats till",
      "currency": "Valutor"
    },
    "language": {
      "language": "Språk"
    },
    "sidebar": {
      "sidebar_more": "Sidomeny"
    }
  },
  "blogs": {
    "article": {
      "author_on_date_html": "av {{ author }} efter {{ date }}",
      "older_post": "Äldre artiklar",
      "newer_post": "Nyare artiklar",
      "tags": "Taggar",
      "comment_meta_html": "{{ author }} efter {{ date }}",
      "read_more": "Läs mer"
    },
    "comments": {
      "title": "Lämna en kommentar",
      "name": "Ditt namn",
      "email": "Din e-postadress",
      "message": "Din kommentar",
      "post": "Plats kommentar",
      "moderated": "Tänk på att svaren måste godkännas innan de syns.",
      "success_moderated": "Din kommentar har publicerats! När det väl är godkänt kommer det att visas på webbplatsen.",
      "success": "Tack! Din kommentar har publicerats.",
      "note": "Alla kommentarer kontrolleras innan de publiceras",
      "in_latest_new": "De senaste nyheterna",
      "post_by": "Artikel av",
      "comments_with_count": {
        "one": "{{ count }} kommentar",
        "other": "{{ count }} kommentarer"
      }
    },
    "sidebar": {
      "recent_articles": "Senaste artiklar",
      "tag_cloud": "Artikel taggar",
      "categories": "Kategorier",
      "placeholder": "Ange dina nyckelord"
    }
  },
  "cart": {
    "general": {
      "title": "Min kundvagn",
      "remove": "Avlägsna",
      "note": "Särskilda instruktioner för HealthyPeople",
      "subtotal": "Delsumma",
      "shipping_at_checkout": "Gratis frakt och moms ingår.",
      "update": "Uppdatera kundvagn",
      "checkout": "Att kassan",
      "button_checkout": "Fortsätt att kassan",
      "empty": "Din vagn är tom.",
      "continue_browsing_html": "Klicka <a href=\"\/\">här<\/a> för att fortsätta handla.\n",
      "view_cart": "Kontrollera kundvagn",
      "close_cart": "Stänga",
      "shopping_cart": "Kundvagn",
      "cart_supermarket": "Kundvagn",
      "label": "Notera",
      "label_text": "Ytterligare kommentarer",
      "shipping_calculator_button": "Beräkna fraktkostnader",
      "shipping_calculator_calculating": "Beräkna...",
      "shipping_calculator_error_message": "Hoppsan! Ange rätt adressinformation.",
      "shipping_calculator_success_many_rates": {
        "there_are": "Det finns",
        "shipping_rates_available_for": "fraktalternativ tillgängliga för",
        "starting_at": ", med början vid"
      },
      "shipping_calculator_success_one_rate": "Det finns ett fraktalternativ tillgängligt för",
      "shipping_calculator_success_no_rate": "Det finns inga fraktalternativ tillgängliga för denna beställning med det mottagande landet.",
      "shipping_calculator_success_at": "bi"
    },
    "label": {
      "product": "Artiklar",
      "price": "Pris",
      "quantity": "Antal",
      "total": "Total",
      "or": "eller",
      "quick_cart": "Kundvagn",
      "your_order": "Du beställer",
      "order_summary": "Beställningsöversikt"
    },
    "ajax_cart": {
      "continue_shopping": "Fortsätt handla",
      "go_to_cart": "Gå till kundvagnen",
      "success_text": "har lagts till i din kundvagn.",
      "error": "Något gick snett",
      "loading": "Ladda",
      "close": "Stänga",
      "popup_cart_des": "Följande artiklar har lagts till i din kundvagn",
      "items_in_your_cart": "artiklar i din kundvagn"
    }
  },
  "slideshow": {
    "next_slide": "Nästa bild",
    "previous_slide": "Föregående bild",
    "pause_slideshow": "Pausa bilder",
    "play_slideshow": "Spela bilder",
    "play_video": "Spela filmen",
    "close_video": "Stäng video"
  },
  "collections": {
    "general": {
      "continue_shopping_htnl": "Gå tillbaka till hemsidan och fortsätt handla",
      "click_continue": "här",
      "title_no_matches": "Tomma kategorier",
      "continue_shopping": "Fortsätt handla",
      "no_matches": "Tyvärr finns det inga produkter tillgängliga i denna kategori",
      "link_title": "Visa kategorin {{ title }}",
      "grid_view": "Grid",
      "list_view": "Lista",
      "shop_now": "Shoppa nu",
      "compare_selected": "Jämföra",
      "shop_the_collection": "Handla den här kategorin",
      "show_more": "visa mer",
      "no_more_product": "Nej",
      "items_count": {
        "one": "artikel",
        "other": "artiklar"
      },
      "items_with_count": {
        "one": "{{ count }} artikel",
        "other": "{{ count }} artiklar"
      }
    },
    "sidebar": {
      "types": "Produkttyp",
      "vendors": "Säljare",
      "tags": "Taggar",
      "clear": "Ta bort",
      "clear_all": "Ta bort allt",
      "refined_by": "Filtrera",
      "sidebar_more": "Filtrera"
    },
    "sorting": {
      "title": "Sortera efter",
      "featured": "Utvalda",
      "best_selling": "Bästsäljare",
      "az": "Alfabetiskt, A-Z",
      "za": "Alfabetiskt, Z-A",
      "price_ascending": "Pris, lågt till högt",
      "price_descending": "Pris, högt till lågt",
      "date_descending": "Datum, nytt till gammalt",
      "date_ascending": "Datum, gammalt till nytt"
    },
    "toolbar": {
      "view_as": "Visa som",
      "item_per_page": "Objekt per sida",
      "previous": "Tidigare",
      "next": "Nästa",
      "show": "Visa:",
      "showing": "Visas",
      "all": "Alla",
      "of": "från"
    }
  },
  "contact": {
    "form": {
      "name": "Ditt namn",
      "email": "Din e-postadress",
      "address": "Din fullständiga adress",
      "phone": "Ditt telefonnummer",
      "message": "Din kommentar",
      "placeholder_message": "Skriv din kommentar här",
      "send": "Skicka",
      "submit_contact": "Skicka",
      "send_question": "Skicka din fråga",
      "post_success": "Tack för att du kontaktar oss. Vi återkommer till dig så snart som möjligt."
    }
  },
  "customer": {
    "account": {
      "title": "Mitt konto",
      "details": "Min Information",
      "view_addresses": "Visa adresser",
      "return": "Tillbaka till Min Information",
      "sing_and_create_acc": "Logga in eller skapa ett konto"
    },
    "activate_account": {
      "title": "Aktivera Konto",
      "subtext": "Skapa ditt lösenord och aktivera ditt konto.",
      "password": "Lösenord",
      "password_confirm": "Bekräfta lösenord",
      "submit": "Aktivera Konto",
      "cancel": "Avvisa inbjudan"
    },
    "addresses": {
      "title": "Katalog",
      "default": "Standard",
      "add_new": "Lägg till ny adress",
      "edit_address": "Ändra adress",
      "first_name": "Namn",
      "last_name": "Efternamn",
      "company": "Företag",
      "address1": "Adress 1",
      "address2": "Adress 2",
      "city": "Stad",
      "country": "Land",
      "province": "Provins",
      "zip": "Postnummer",
      "phone": "Telefonnummer",
      "set_default": "Ställ in den här adressen som standardadress",
      "add": "Lägg till adress",
      "update": "Uppdatera adress",
      "cancel": "Avbryt",
      "edit": "Ändra",
      "delete": "Avlägsna",
      "delete_message": "Är du säker på att du vill ta bort den här adressen?"
    },
    "logout": {
      "title": "Kund"
    },
    "login": {
      "title": "Logga in för kunder",
      "account": "Konto",
      "returning_customer": "Återkommande kund",
      "new_customer": "Ny kund",
      "email": "E-postadress",
      "password": "Lösenord",
      "forgot_password": "Glömt ditt lösenord?",
      "sign_in": "Logga in",
      "login": "Logga in",
      "cancel": "Tillbaka till shopping",
      "guest_title": "Tillbaka till butiken",
      "guest_continue": "Fortsätt"
    },
    "orders": {
      "title": "Beställningar",
      "order_number": "Beställa",
      "date": "Datera",
      "payment_status": "Betalningsstatus",
      "fulfillment_status": "Fraktstatus",
      "total": "Total",
      "none": "Du har inte gjort några beställningar än"
    },
    "order": {
      "title": "Beställ {{ name }}",
      "date": "Upplagt den {{ date }}",
      "cancelled": "Beställningen avbröts den {{ date }}",
      "cancelled_reason": "Anledning till avbokning: {{ reason }}",
      "billing_address": "Fakturaadress",
      "payment_status": "Betalningsstatus",
      "shipping_address": "Leveransadress",
      "fulfillment_status": "Fraktstatus",
      "discount": "Rabatt",
      "shipping": "Fraktkostnader",
      "tax": "Beskatta",
      "product": "Artikel",
      "sku": "SKU",
      "price": "Pris",
      "quantity": "Antal",
      "total": "Total",
      "fulfilled_at": "Skickad på {{ date }}",
      "subtotal": "Delsumma"
    },
    "recover_password": {
      "title": "Återställ lösenord",
      "email": "E-postadress",
      "submit": "Att skicka",
      "cancel": "Avbryt",
      "subtext": "Vi skickar ett e-postmeddelande för att återställa ditt lösenord.",
      "success": "Vi har skickat ett e-postmeddelande med en länk för att återställa ditt lösenord."
    },
    "reset_password": {
      "title": "Återställ ditt lösenord",
      "subtext": "Ange ett nytt lösenord för {{ email }}",
      "password": "Lösenord",
      "password_confirm": "Bekräfta lösenord",
      "submit": "Återställ lösenord"
    },
    "register": {
      "title": "Skapa ett konto",
      "register": "Registrera",
      "first_name": "Namn",
      "last_name": "Efternamn",
      "email": "E-postadress",
      "password": "Lösenord",
      "submit": "Skapa ett konto",
      "cancel": "Återgå till shopping"
    },
    "form": {
      "error_message": "Hoppsan! Något verkar gå fel. Kontrollera vad du angav och försök igen."
    }
  },
  "home_page": {
    "sections": {
      "frontpage_title": "Home Kategori",
      "featured_title": "Utvalda Kategorier",
      "news_title": "Senaste nytt"
    },
    "onboarding": {
      "modal_title": "Nästan färdig...",
      "no_products_html": "Du har inga artiklar på kategorins startsida. Denna exempeltext förblir synlig tills du <a href=\"\/admin\/collections?tutorial=Frontpage\"> lägger till en artikel i denna kategori<\/a>.",
      "add_product": "Lägg till artikel",
      "product_title": "Exempel på artikelrubrik",
      "no_collections_html": "Du har inga kategorier att visa här. <a href=\"\/admin\/custom_collections\"> Lägg till kategorier <\/a> för att visas på startsidan.\n",
      "add_collection": "Lägg till Kategorier",
      "collection_title": "Exempel på kategorititel"
    },
    "show_more": "Visa mer",
    "no_more_product": "Inga fler artiklar"
  },
  "layout": {
    "navigation": {
      "menu": "Meny",
      "menu_all": "Allt"
    },
    "cart": {
      "title": "Kundvagn",
      "items_count": {
        "one": "artikel",
        "other": "artiklar"
      }
    },
    "customer": {
      "account": "Konto",
      "logged_in_as_html": "Inloggad som {{ first_name }}",
      "log_out": "Logga ut",
      "log_in": "Logga in",
      "create_account": "Skapa ett konto",
      "register": "Registrera",
      "title": "Mitt Konto"
    },
    "footer": {
      "linklist_title": "Snabb åtkomst",
      "newsletter_title": "Nyhetsbrev",
      "accepted_payments": "Betrodda betalningar",
      "social_title": "Följ oss"
    }
  },
  "products": {
    "general": {
      "previous_product_html": "&larr; Föregående produkt",
      "next_product_html": "Nästa artikel &rarr;",
      "from": "Från"
    },
    "product": {
      "sale": "Försäljning",
      "you_save": "Du sparar",
      "hot_label": "Populär",
      "bundle_label": "Bunt",
      "new_label": "Ny",
      "sold_out": "Ej i lager",
      "on_sale_from_html": "<strong>Försäljning<\/strong> från {{ price }}",
      "unavailable": "Inte tillgänglig",
      "compare_at": "I jämförelse med",
      "quantity": "Antal",
      "add_to_cart": "Lägg i kundvagn",
      "pre_order": "Förbeställ",
      "add_all_to_cart": "Lägg till allt i kundvagnen",
      "buy_now": "Köp nu",
      "add": "Tillägga",
      "select_options": "Välj inställningar",
      "quick_view": "Visa Snabbt",
      "in_stock": "I lager",
      "out_of_stock": "Ej i lager",
      "many_in_stock": "Mycket i lager",
      "details": "Detaljer",
      "from": "från",
      "show_options": "Visa alternativ",
      "hide_options": "Dölj alternativ",
      "adding": "Tillägga...",
      "thank_you": "Tack!",
      "add_more": "Lägga till mer",
      "cart_feedback": "Lagt till",
      "main_product": "Denna artikel"
    }
  },
  "gift_cards": {
    "issued": {
      "title": "Här är ditt presentkort från {{ value }} för {{ shop }}!",
      "subtext": "Här är ditt presentkort!",
      "disabled": "Utgånget",
      "expired": "Gäller ut {{ expiry }}",
      "active": "Gäller ut {{ expiry }}",
      "redeem": "Använd denna rabattkod i kassan för att använda ditt presentkort",
      "shop_link": "Börja handla",
      "print": "Skriva ut"
    }
  },
  "date_formats": {
    "month_day_year": "%B %d, %Y"
  },
  "wishlist": {
    "general": {
      "my_wishlist": "Min Önskelista",
      "wishlist": "Önskelistor",
      "product_image": "Artikelbild",
      "product_name": "Artikelnamn",
      "unit_price": "Enhetspris",
      "share_wishlist": "Dela min Önskelista via e-post",
      "no_login_html": "För att skapa en Önskelista, vänligen <a href=\"\/account\/login\"> logga in <\/a> eller <a href=\"\/account\/register\"> ett konto skapa <\/a>.",
      "add_to_wishlist": "Lägg till i Önskelista",
      "remove_wishlist": "Ta bort från Önskelistan",
      "note": "Denna artikel är redan på din Önskelista. Gå till din Önskelista.",
      "subtext": "För att skapa en Önskelista skickar du in",
      "sign_in": "logga in",
      "or": "eller",
      "wishlist_empty": "Det verkar som om du inte har skapat en Önskelista än ...",
      "create_account": "Skapa ett konto"
    }
  },
  "shopify": {
    "checkout": {
      "contact": {
        "address1_label": "Gata",
        "address2_label": "Husnummer"
      },
      "field_errors": {
        "address_address2_blank": "Glöm inte att ange ditt husnummer"
      },
      "general": {
        "cart": "Kundvagn"
      },
      "order_summary": {
        "shopping_cart_label": "Kundvagn"
      },
      "change_country": {
        "cart_updated_based_on_country": "Din kundvagn har uppdaterats baserat på ditt leveransland."
      }
    },
    "notices": {
      "cart": {
        "only_n_items_available": "Du kan bara lägga till {{ count }} {{ name }} till din kundvagn.",
        "too_many_items_in_cart": "Du kan inte lägga till fler {{ name }} i kundvagn.",
        "all_items_in_cart": "{{ count }}{{ name }} finns i din kundvagn."
      }
    },
    "page_titles": {
      "shopping_cart": "Din kundvagn"
    }
  }
}